import ProtectedRoute from "../router/ProtectedRoute";
import PrivateRoute from "../router/PrivateRoute";
import Layout from "./Layout";

type RouteWrapperProps = Readonly<{
  isProtected?: boolean;
  isPrivate?: boolean;
  enableLayout?: boolean;
  element: JSX.Element;
}>;

function RouteWrapper({
  isProtected = false,
  isPrivate = true,
  enableLayout = true,
  element,
}: RouteWrapperProps): React.ReactElement | null {
  let renderElement = element;
  if (isProtected) {
    renderElement = <ProtectedRoute>{element}</ProtectedRoute>;
  } else if (isPrivate) {
    renderElement = <PrivateRoute>{element}</PrivateRoute>;
  }
  return enableLayout ? <Layout>{renderElement}</Layout> : renderElement;
}

export default RouteWrapper;
